import React from 'react';
import Button from 'kingpin/atoms/Button';

const ResetReportButton = ({ onClick }: { onClick: () => void }) => (
  <Button
    onClick={onClick}
    type="Ghost"
    size="Small"
    label="Clear all"
    testId="clear-all"
  />
);

export default ResetReportButton;
